import { Reducer } from "redux";

import { ConversionsWidgetAction, ConversionsWidgetActionTypes, ConversionsWidgetState } from "./types";

const initialState: ConversionsWidgetState = {
  isLoading: false,
  isPreviousLoading: false,
};

const reducer: Reducer<ConversionsWidgetState, ConversionsWidgetAction> = (state = initialState, action) => {
  switch (action.type) {
    case ConversionsWidgetActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case ConversionsWidgetActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case ConversionsWidgetActionTypes.FETCH_SUCCESS: {
      const { searches, clicks, bookings, dateTo, dateFrom, lastUpdate } = action.payload;
      return { ...state, searches, clicks, bookings, dateTo, dateFrom, lastUpdate, isLoading: false };
    }

    case ConversionsWidgetActionTypes.PREVIOUS_FETCH_REQUEST: {
      return { ...state, isPreviousLoading: true };
    }

    case ConversionsWidgetActionTypes.PREVIOUS_FETCH_ERROR: {
      return { ...state, isPreviousLoading: false };
    }

    case ConversionsWidgetActionTypes.PREVIOUS_FETCH_SUCCESS: {
      const { searches, clicks, bookings, dateTo, dateFrom, lastUpdate } = action.payload;
      return {
        ...state,
        lastUpdate,
        previousSearches: searches,
        previousClicks: clicks,
        previousBookings: bookings,
        previousDateTo: dateTo,
        previousDateFrom: dateFrom,
        isPreviousLoading: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
